import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Book } from '../model/models';

const REST_API = 'api/books';
@Injectable({
  providedIn: 'root'
})
export class RestBookDao {

  constructor(private httpClient: HttpClient) { }

  getBooks(): Observable<Book[]> {
    return this.httpClient.get<Map<number, Book>>(REST_API)
      .pipe(
        map(response => Array.from(response.values())
          .map(book => ({ ...book, awardWins: [] })))
      )
      ; //TODO awards
  }

  saveBook(book: Book): Observable<Book> {
    return this.httpClient.post<any>(REST_API, book, { observe: 'response' })
      .pipe(map(response => {
        const id = response.headers.get('location')?.replace('/books/', '');
        book.id = parseInt(id!);
        return book;
      }));
  }

  updateBook(book: Book): Observable<Book> {
    return this.httpClient.put<any>(REST_API + "/" + book.id, book);
  }
}
